/**
 * EquipmentSections - Extracted from StepSystems for file size management
 * Handles navigation, communication, and electrical equipment sections
 */

import React from 'react';
import { Radio, Zap, Navigation } from 'lucide-react';
import WizardSection from '../../WizardSection';
import { navigationEquipmentOptions, communicationEquipmentOptions, electricalSystemsOptions } from '../utils/systemsEquipmentData';

const EquipmentSections = ({ 
  draftConfig, 
  renderEquipmentOption 
}) => {
  return (
    <>
      {/* Navigation Equipment Section */}
      <WizardSection.Card>
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="bg-blue-100 p-2 rounded-lg">
              <Navigation className="w-5 h-5 text-blue-600" />
            </div>
            <div>
              <WizardSection.Header level="h2">Navigation Equipment</WizardSection.Header>
              <p className="text-sm text-gray-600 mt-1">Position fixing and navigation systems</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-500">
              {(draftConfig.navigationEquipment || []).length} of {navigationEquipmentOptions.length} selected
            </span>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {navigationEquipmentOptions.map(option => 
            renderEquipmentOption(option, 'navigationEquipment')
          )}
        </div>
      </WizardSection.Card>

      {/* Communication Equipment Section */}
      <WizardSection.Card>
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="bg-green-100 p-2 rounded-lg">
              <Radio className="w-5 h-5 text-green-600" />
            </div>
            <div>
              <WizardSection.Header level="h2">Communication Equipment</WizardSection.Header>
              <p className="text-sm text-gray-600 mt-1">GMDSS and emergency communication systems</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-500">
              {(draftConfig.communicationEquipment || []).length} of {communicationEquipmentOptions.length} selected
            </span>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {communicationEquipmentOptions.map(option => 
            renderEquipmentOption(option, 'communicationEquipment')
          )}
        </div>
      </WizardSection.Card>

      {/* Electrical Systems Section */}
      <WizardSection.Card>
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="bg-yellow-100 p-2 rounded-lg">
              <Zap className="w-5 h-5 text-yellow-600" />
            </div>
            <div>
              <WizardSection.Header level="h2">Electrical Systems</WizardSection.Header>
              <p className="text-sm text-gray-600 mt-1">Power distribution and monitoring systems</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-500">
              {(draftConfig.electricalSystems || []).length} of {electricalSystemsOptions.length} selected
            </span>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {electricalSystemsOptions.map(option => 
            renderEquipmentOption(option, 'electricalSystems')
          )}
        </div>
      </WizardSection.Card>
    </>
  );
};

export default EquipmentSections;